import React from 'react'
import { Placement } from '@floating-ui/react'
import { TooltipArrowProps } from '../types'

export const TooltipArrow = React.forwardRef<HTMLDivElement, TooltipArrowProps>(
  ({ placement, className = '' }, ref) => {
    // 根据位置计算箭头的样式
    const getArrowStyles = (placement: Placement) => {
      const side = placement.split('-')[0]

      switch (side) {
        case 'top':
          return {
            bottom: '-4px',
            left: '50%',
            transform: 'translateX(-50%)',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderTop: '4px solid #242424', // bg-special-tooltip
          }
        case 'bottom':
          return {
            top: '-4px',
            left: '50%',
            transform: 'translateX(-50%)',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            borderBottom: '4px solid #242424',
          }
        case 'left':
          return {
            right: '-4px',
            top: '50%',
            transform: 'translateY(-50%)',
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            borderLeft: '4px solid #242424',
          }
        case 'right':
          return {
            left: '-4px',
            top: '50%',
            transform: 'translateY(-50%)',
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            borderRight: '4px solid #242424',
          }
        default:
          return {}
      }
    }

    const arrowStyles = getArrowStyles(placement)

    return (
      <div
        ref={ref}
        className={`absolute w-0 h-0 ${className}`}
        style={arrowStyles}
      />
    )
  }
)

TooltipArrow.displayName = 'TooltipArrow'
